/**
 * Underscore as a service
 *
 * temporary. switch to lodash and import individual functions
 */

import * as underscore from "underscore";
export function _() {
  return underscore;
}
